import React from "react";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";

import Card from "../common/card";

import "./styles/work.css";

const Works = () => {
	return (
		<div className="home-works">
			<Card
				icon={faBriefcase}
				title="Work"
				body={
					<div className="home-works-body">
						<div className="home-work">
							<div className="home-work-header">
								<div className="home-work-left">
									<img
										src="./robinhood.png"
										alt="robinhood"
										className="home-work-image"
									/>
									<div className="home-work-company">Robinhood</div>
								</div>
								<div className="home-work-duration">Aug 2025 - Present</div>
							</div>
							<div className="home-work-position">Software Engineer</div>
						</div>

						<div className="home-work">
							<div className="home-work-header">
								<div className="home-work-left">
									<img
										src="./cresta.png"
										alt="cresta"
										className="home-work-image"
									/>
									<div className="home-work-company">Cresta</div>
								</div>
								<div className="home-work-duration">Jun 2024 - Aug 2025</div>
							</div>
							<div className="home-work-position">Software Engineer</div>
						</div>

						<div className="home-work">
							<div className="home-work-header">
								<div className="home-work-left">
									<img
										src="./huawei.png"
										alt="huawei"
										className="home-work-image"
									/>
									<div className="home-work-company">Huawei</div>
								</div>
								<div className="home-work-duration">Feb 2023 - Jun 2024</div>
							</div>
							<div className="home-work-position">Software Engineer</div>
						</div>
					</div>
				}
			/>
		</div>
	);
};

export default Works;
